import React from 'react';

import PlainText from 'ati-ui-react/components/PlainText';
import Heading from 'ati-ui-react/components/Heading';
import Separator from 'ati-ui-react/components/Form/Separator';

import * as styles from './ErrorPage.scss';
import ErrorIcon from './ErrorIcon';

const AppErrorPage = ({ title, subtitle, description }) => (
  <div className={styles.errorPage}>
    <div className={styles.errorMessageLayout}>
      <div className={styles.iconContainer}>
        <ErrorIcon />
      </div>
      <div className={styles.messageContainer}>
        {subtitle &&
          <div className={styles.subtitle}>
            <PlainText className={styles.plainText} size="medium">
              {subtitle}
            </PlainText>
          </div>
        }
        <div className={styles.title}>
          <Heading className={styles.heading} h2>{title}</Heading>
        </div>
        <div className={styles.description}>
          <PlainText className={styles.plainText} size="small">
            {description}
          </PlainText>
        </div>
        <div className={styles.divider}>
          <Separator />
        </div>
      </div>
    </div>
  </div>
);

export default AppErrorPage;
